module.exports = __webpack_public_path__ + "assets/img/zhtwo.dd21bd90.png";